import React from "react";
import Head from "next/head";

import seoData from "@/data/seo/page-data.json";
import SeoMetaData from "@/components/utils/seo-metadata";
import PurolatorShipNow from "@/components/fulfilment-partners/purolator-ship-now";

const PurolatorPartner = () => {
  return (
    <>
      <Head>
        <title>{seoData.PARTNER.title}</title>
        <SeoMetaData data={seoData.PARTNER} />
      </Head>

      <PurolatorShipNow />
    </>
  );
};

export default PurolatorPartner;
